/**
 * WorkspaceModeRenderer - Renders content based on active mode
 * Handles mode transitions and passes workspace context
 */

import { useWorkspaceStore } from '@/stores/workspaceStore'
import { DashboardMode } from './modes/DashboardMode'
import { FullAIAssistantMode } from './modes/FullAIAssistantMode'
import { CanvasMode } from './modes/CanvasMode'
import { SmartDocMode } from './modes/SmartDocMode'
import { EntitiesMode } from './modes/EntitiesMode'
import { FlowMode } from './modes/FlowMode'

interface WorkspaceModeRendererProps {
  onOpenGoalWizard?: () => void
}

export function WorkspaceModeRenderer({ onOpenGoalWizard }: WorkspaceModeRendererProps) {
  const { activeMode, workspaceContext } = useWorkspaceStore()

  return (
    <div className="h-full w-full">
      {activeMode === 'dashboard' && (
        <DashboardMode context={workspaceContext} onOpenGoalWizard={onOpenGoalWizard} />
      )}
      {activeMode === 'full-ai' && (
        <FullAIAssistantMode context={workspaceContext} />
      )}
      {activeMode === 'canvas' && <CanvasMode context={workspaceContext} />}
      {activeMode === 'smart-doc' && (
        <SmartDocMode context={workspaceContext} />
      )}
      {activeMode === 'entities' && <EntitiesMode context={workspaceContext} />}
      {activeMode === 'flow' && <FlowMode context={workspaceContext} />}
    </div>
  )
}
